import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-header">
          <h1 className="about-title">About CBC Center</h1>
          <p className="about-subtitle">
            Empowering Kenya's education transformation through quality CBC resources
          </p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2 className="section-title">Our Mission</h2>
            <p className="section-text">
              CBC Center is dedicated to providing comprehensive, accessible, and high-quality 
              Competency-Based Curriculum (CBC) resources for students, teachers, and parents 
              across Kenya. We believe that every learner deserves equal access to quality 
              educational materials that support their academic journey.
            </p>
          </section>

          <section className="about-section">
            <h2 className="section-title">What We Offer</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">📚</div>
                <h3>Curriculum Resources</h3>
                <p>Complete CBC syllabus coverage with up-to-date content aligned with national standards.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🎯</div>
                <h3>Assessment Materials</h3>
                <p>Past papers, revision questions, and practice tests for all grade levels.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">👨‍🏫</div>
                <h3>Teacher Support</h3>
                <p>Lesson plans, teaching guides, and professional development resources.</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2 className="section-title">Important Notice</h2>
            <div className="disclaimer-section">
              <div className="disclaimer-alert">
                <div className="disclaimer-icon">⚠️</div>
                <div className="disclaimer-content">
                  <h4 className="disclaimer-title">Disclaimer</h4>
                  <p className="disclaimer-text">
                    <strong>CBC Center is an independent educational resource platform and is not affiliated with, 
                    endorsed by, or connected to any government agency, including the Ministry of Education 
                    or the Kenya Institute of Curriculum Development (KICD).</strong>
                  </p>
                  <p className="disclaimer-text">
                    While we strive to align our resources with the official Competency-Based Curriculum, 
                    we are a separate entity providing supplementary educational materials. For official 
                    curriculum documents, announcements, and government directives, please refer to the 
                    official government education portals.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2 className="section-title">Our Commitment</h2>
            <div className="commitment-list">
              <div className="commitment-item">
                <span className="checkmark">✓</span>
                <span><strong>Free Access:</strong> All resources are completely free forever</span>
              </div>
              <div className="commitment-item">
                <span className="checkmark">✓</span>
                <span><strong>Quality Assurance:</strong> All materials reviewed by certified educators</span>
              </div>
              <div className="commitment-item">
                <span className="checkmark">✓</span>
                <span><strong>Regular Updates:</strong> Content updated to match curriculum changes</span>
              </div>
              <div className="commitment-item">
                <span className="checkmark">✓</span>
                <span><strong>Mobile-Friendly:</strong> Accessible on all devices, anywhere</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;